// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_exn from "../../../../node_modules/rescript/lib/es6/js_exn.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Caml_js_exceptions from "../../../../node_modules/rescript/lib/es6/caml_js_exceptions.js";
function useIdleCallback(fallbackTimeoutMsOpt, param) {
  var fallbackTimeoutMs = fallbackTimeoutMsOpt !== undefined ? fallbackTimeoutMsOpt : 500;
  var idleCallbackRef = React.useRef(undefined);
  var timeoutRef = React.useRef(undefined);
  var clearExistingTimeout = function (param) {
    Belt_Option.map(timeoutRef.current, function (prim) {
      clearTimeout(prim);
    });
  };
  var cancelExistingCallback = function (param) {
    try {
      var partial_arg = window;
      Belt_Option.map(idleCallbackRef.current, function (param) {
        partial_arg.cancelIdleCallback(param);
      });
      return;
    } catch (exn) {
      return clearExistingTimeout(undefined);
    }
  };
  React.useEffect(function () {
    return function (param) {
      cancelExistingCallback(undefined);
    };
  }, []);
  return function (callbackFn) {
    cancelExistingCallback(undefined);
    try {
      idleCallbackRef.current = Caml_option.some(window.requestIdleCallback(function (param) {
        Curry._1(callbackFn, undefined);
      }));
      return;
    } catch (raw_obj) {
      var obj = Caml_js_exceptions.internalToOCamlException(raw_obj);
      if (obj.RE_EXN_ID === Js_exn.$$Error) {
        clearExistingTimeout(undefined);
        timeoutRef.current = Caml_option.some(setTimeout(callbackFn, fallbackTimeoutMs));
        return;
      }
      throw obj;
    }
  };
}
export { useIdleCallback };
/* react Not a pure module */